import { useQuery } from "@tanstack/react-query";

import { ScreenerService } from "../services/screener-service";
import { screenerKeys } from "./queries";

export function useScreenerPreferences(scope: "stocks" | "etf") {
  return useQuery({
    queryKey: screenerKeys.prefs.byScope(scope),
    queryFn: () => ScreenerService.getScreenerPreference(scope),
    staleTime: 5 * 60_000,
  });
}
